const EarnType = {
  SUBSCRIPTION: 'subscribe',
  REDEMPTION: 'redeem'
};

export const getEarnTypeTranslationKey = (type: string) => {
  if (!Object.keys(EarnType).includes(type)) {
    return type;
  }

  const key = EarnType[type as keyof typeof EarnType];
  return `earn-invest::glossary.${key}`;
};
